import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the collaboratorsCreate state domain
 */

const selectCollaboratorsCreateDomain = (state) =>
  state.get("collaboratorsCreate", initialState)

export const MakeSelectIsCreating = () =>
  createSelector(selectCollaboratorsCreateDomain, (state) =>
    state.get("isCreating")
  )

export const MakeSelectDivisions = () =>
  createSelector(selectCollaboratorsCreateDomain, (state) =>
    state.get("divisions")
  )

export const MakeSelectGenders = () =>
  createSelector(selectCollaboratorsCreateDomain, (state) =>
    state.get("genders")
  )

export const MakeSelectLocations = () =>
  createSelector(selectCollaboratorsCreateDomain, (state) =>
    state.get("locations")
  )
export const MakeSelectLeaders = () =>
  createSelector(selectCollaboratorsCreateDomain, (state) =>
    state.get("leaders")
  )

export const MakeSelectCategories = () =>
  createSelector(selectCollaboratorsCreateDomain, (state) =>
    state.get("categories")
  )

export const MakeSelectCurrency = () =>
  createSelector(selectCollaboratorsCreateDomain, (state) =>
    state.get("currency")
  )

export const MakeSelectIsLoadingDivisions = () =>
  createSelector(selectCollaboratorsCreateDomain, (state) =>
    state.get("isLoadingDivisions")
  )

export const MakeSelectIsLoadingGenders = () => createSelector(selectCollaboratorsCreateDomain, (state) =>
  state.get("isLoadingGenders")
)

export const MakeSelectIsLoadingEmployees= () => createSelector(selectCollaboratorsCreateDomain, (state) =>
  state.get("isLoadingLeaders")
)

export const MakeSelectIsLoadingLocations= () => createSelector(selectCollaboratorsCreateDomain, (state) =>
  state.get("isLoadingLocations")
)

export const MakeSelectIsLoadingCategories = () =>
  createSelector(selectCollaboratorsCreateDomain, (state) =>
    state.get("isLoadingCategories")
  )

export const MakeSelectIsLoadingCurrency = () =>
  createSelector(selectCollaboratorsCreateDomain, (state) =>
    state.get("isLoadingCurrency")
  )

const makeSelectCollaboratorsCreate = () =>
  createSelector(selectCollaboratorsCreateDomain, (substate) => substate.toJS())

export default makeSelectCollaboratorsCreate
export { selectCollaboratorsCreateDomain }
